import { FETCH_ARTIST_DETAIL, FETCH_ARTIST_SOCIAL_LINKS, FETCH_ARTISTS } from "./actions"
import { PaginatedData } from "../../types/root"
import { Artist, ArtistsActionProps, ArtistSocialLink, ArtistsProps } from "../../types/artists"

export const initialArtistsState: ArtistsProps = {
  paginatedArtists: new PaginatedData<Artist>(),
  paginatedArtistDetail: new PaginatedData<Artist>(),
  artistSocialLinks: {}
}

const artists = (state = initialArtistsState, action: ArtistsActionProps) => {
  switch (action.type) {
    case FETCH_ARTISTS: {
      const paginatedArtists =
        (action.payload?.paginatedArtists as PaginatedData<Artist>) || new PaginatedData<Artist>()
      return {
        ...state,
        paginatedArtists
      }
    }
    case FETCH_ARTIST_DETAIL: {
      const paginatedArtistDetail =
        (action.payload?.paginatedArtistDetail as PaginatedData<Artist>) || new PaginatedData<Artist>()
      return {
        ...state,
        paginatedArtistDetail
      }
    }
    case FETCH_ARTIST_SOCIAL_LINKS: {
      const artistSocialLinks = (action.payload?.artistSocialLinks as ArtistSocialLink) || {}
      return {
        ...state,
        artistSocialLinks
      }
    }
    default: {
      return { ...state }
    }
  }
}

export default artists
